import { storeAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
import store from '@/store';
const { accumulate, fav, products, categories, categoryProducts, isOnline } = storeAPI;

export default {
  async fetchStoreList({ state, commit }, payload) {
    const { page, limit, totalPage } = state.store.pageInfo;
    const filter = filterToParam();
    const userPosition = store.getters['user/getUserPosition'];

    if (page > totalPage) return;
    const customParam = {
      page,
      limit,
      ...payload,
      ...filter,
      ...userPosition
    };

    customParam.isRecommended = false;
    if (!customParam.storeCategoryNo) delete customParam.storeCategoryNo;

    const { data, status } = await ServiceExec.get(storeAPI.storeList, customParam);

    if (status !== 200) return false;
    const { list, pageInfo } = data;
    // commit('setStorePageInfo', pageInfo);
    commit('setStorePage', page + 1);
    commit('setStoreTotalPage', pageInfo?.totalPage ?? 2);
    commit('setStoreList', list ?? []);
  },

  async fetchRecommendedStoreList({ state, commit }, payload) {
    const { page, limit, totalPage } = state.recommended.pageInfo;
    const filter = filterToParam();
    const userPosition = store.getters['user/getUserPosition'];

    if (page > totalPage) return;
    const customParam = {
      page,
      ...payload,
      ...filter,
      ...userPosition
    };

    customParam.isRecommended = true;
    if (!customParam.storeCategoryNo) delete customParam.storeCategoryNo;

    const { data, status } = await ServiceExec.get(storeAPI.storeList, customParam);

    if (status !== 200) return false;
    const { pageInfo, list } = data;
    commit('setRecommendedStoreList', list ?? []);
  },

  async fetchStoreListByTag({ state, commit }, payload) {
    const { page, totalPage, limit } = state.store.pageInfo;
    const userPosition = store.getters['user/getUserPosition'];
    const customParam = {
      page,
      limit,
      ...payload,
      ...userPosition
    };
    const { data, status } = await ServiceExec.get(storeAPI.storeList, customParam);

    if (status !== 200) return;
    const { list, pageInfo } = data;
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setStoreList', list ?? []);
  },
  async getStoreDetail({ commit }, { storeNo, userNo = -1 }) {
    const { data } = await ServiceExec.get(storeAPI.store_detail(storeNo), {
      userNo
    });
    commit('setStoreInfo', data);
    return data;
  },
  async getStoreFavorite({ commit }, { storeNo, userNo = -1 }) {
    const { data } = await ServiceExec.get(storeAPI.store_favorite(storeNo), {
      userNo
    });
    commit('setStoreFav', data);
    return data;
  },
  SAVE_ACCUMULATE: ({ commit }, payload) => {
    ServiceExec.post(accumulate, payload);
  },
  TOGGLE_FAV: async ({ commit }, params = { userNo, storeNo }) => {
    const { status, data } = await ServiceExec.post(fav, params);
    if (status === ServiceExec.status.OK) {
      commit('setStoreFav', data);
    }
  },
  FETCH_PRODUCTS: async ({ commit, getters }, { storeNo, limit = -1 }) => {
    const params = { storeNo, page: 1, limit };
    const { status, data } = await ServiceExec.get(products(storeNo), params);

    if (status === ServiceExec.status.OK) {
      // Object.keys(data).forEach((key) => (data[key].isFold = false));
      // commit('setRecentProducts', data);
    }
  },
  FETCH_CATEGORIES: async (
    { commit, getters },
    { storeNo, searchText, isMain, categoryText, isNoSearch, isWithProduct }
  ) => {
    const { status, data } = await ServiceExec.get(categories(storeNo), {
      searchText,
      isMain,
      categoryText,
      isWithProduct,
      isNoSearch
    });
    if (status === ServiceExec.status.OK) {
      commit('setProducts', data);
    }
  },
  FETCH_ALL_CATEGORIES: async (
    { commit, getters },
    { storeNo, searchText, isMain, categoryText, isWithProduct }
  ) => {
    const { status, data } = await ServiceExec.get(categories(storeNo), {
      searchText,
      isMain,
      categoryText,
      isWithProduct
    });
    if (status === ServiceExec.status.OK) {
      commit('setAllProducts', data);
    }
  },
  FETCH_CATEGORY_PRODUCTS: async ({ commit, getters }, { storeNo, productCategoryNo, limit, searchText = '' }) => {
    const { page, totalPage } = getters['getProductsPageInfo'];

    if (page > totalPage) return;

    const { status, data } = await ServiceExec.get(categoryProducts(storeNo, productCategoryNo), {
      limit,
      page,
      searchText
    });
    if (status === ServiceExec.status.OK) {
      const { list, pageInfo } = data;
      const { totalPage } = pageInfo;
      commit('setCategoryProduct', { productCategoryNo, products: list, page });
      commit('setCategoryProductPageInfo', { page: page + 1, totalPage });
    }
  },
  FETCH_SEARCH_CATEGORY_PRODUCTS: async (
    { commit, getters },
    { storeNo, productCategoryNo, limit, searchText = '', notLoading = false }
  ) => {
    const { page, totalPage } = getters['getProductsPageInfo'];

    if (page > totalPage) return;

    const { status, data } = await ServiceExec.get(categoryProducts(storeNo, productCategoryNo), {
      limit,
      page,
      searchText,
      notLoading
    });
    if (status === ServiceExec.status.OK) {
      const { list, pageInfo } = data;
      const { totalPage } = pageInfo;
      commit('setSearchCategoryProduct', { list, page });
      commit('setCategoryProductPageInfo', { page: page + 1, totalPage });
    }
  },
  FETCH_IS_ONLINE: async ({ commit }, { userNo }) => {
    const { status, data } = await ServiceExec.get(isOnline(userNo));
    if (status == ServiceExec.status.OK) commit('setStoreOnline', data);
  },

  /**
   * 상점 조회수 증가
   * @param commit
   * @param storeNo
   */
  hitStore: ({ commit }, storeNo) => {
    let user = store.getters['user/getUserData'];
    ServiceExec.patch(storeAPI.hit(storeNo));
  }
};

const filterToParam = () => {
  const filter = store.getters['search/getFilter'];

  return {
    storeOrderByCondition: filter['STORE_ORDER_BY_CONDITION'],
    storeDeliveryFeeCondition: filter['STORE_DELIVERY_FEE_CONDITION'],
    storeRequiredPayAmountCondition: filter['STORE_REQUIRED_PAY_AMOUNT_CONDITION'],
    storeStarCondition: filter['STORE_STAR_CONDITION'],
    storeEtcCondition: filter['STORE_ETC_CONDITION']
  };
};
